import React from 'react'

export const NavBar = () => {
  return (
    <header>
        <h1 className="text-left m-8 text-2xl font-bold">Raza de perro</h1>
    </header>
  )
}
